module.exports = __webpack_public_path__ + "static/media/aq.c61dd421.svg";